<template>
    <v-card
            class="contact-property pa-6 py-4"
            outlined
    >

        <v-row>
            <v-col class="pb-0">
               <h4 class="text-center">Contact Property</h4>
            </v-col>
        </v-row>
        <v-row v-if="isUserLoggedIn" class="phone">
            <v-col class="pb-4 text-center d-flex align-center justify-center">
                <v-img src="@/assets/icons/icon-phone.svg" contain max-height="18" max-width="18" class="mr-2"></v-img>
                <span>Call <a @click.prevent="onPropertyContact">{{showPhoneNumber ? property.phone_number : '*******'}}</a></span>
            </v-col>
        </v-row>
        <v-row v-if="isUserLoggedIn === false" class="phone">
            <v-col class="pb-4 text-center d-flex align-center justify-center">
                <v-img src="@/assets/icons/icon-phone.svg" contain max-height="18" max-width="18" class="mr-2"></v-img>
                <span>Call <a @click.prevent="openSignIn">{{'*******'}}</a></span>
            </v-col>
        </v-row>
        <form>
            <v-row>
                <v-col class="pb-1">
                    <v-text-field
                            v-model="name"
                            :error-messages="nameErrors"
                            label="Full Name"
                            required
                            outlined
                            @input="$v.name.$touch()"
                            @blur="$v.name.$touch()"
                            hide-details="auto"
                            class="btn-edu-height"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="pb-1">
                    <v-text-field
                            v-model="email"
                            :error-messages="emailErrors"
                            label="Email Address"
                            required
                            outlined
                            @input="$v.email.$touch()"
                            @blur="$v.email.$touch()"
                            hide-details="auto"
                            class="btn-edu-height"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="pb-1">
                    <v-text-field
                            v-model="phone"
                            label="Phone Number (optional)"
                            outlined
                            @input="$v.phone.$touch()"
                            @blur="$v.phone.$touch()"
                            hide-details="auto"
                            class="btn-edu-height"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="pb-1">
                    <v-menu
                            v-model="showDob"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                    v-model="moveInDateFormatted"
                                    outlined
                                    append-icon="mdi-calendar-blank-outline"
                                    readonly
                                    dense
                                    placeholder="mm/dd/yyyy"
                                    v-on="on"
                                    label="Move-in Date"
                                    hide-details
                                    class="btn-edu-height"
                            >
                                <template slot="append">
                                    <span>
                                        <v-icon size="18" color="black">mdi-calendar-blank-outline</v-icon>
                                    </span>
                                </template>
                            </v-text-field>
                        </template>
                        <v-date-picker v-model="moveInDate" no-title @input="showDob = false"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-select dense
                      solo
                      flat
                      outlined
                      label="Available Units"
                      :items="availableUnits"
                      item-value="id"
                      item-text="select_label"
                      v-model="propertyUnitId"
                      :error-messages="propertyUnitErrors"
                      light
                    >
                        <template slot="append">
                            <span>
                                <v-icon size="18">mdi-chevron-down</v-icon>
                            </span>
                        </template>
                    </v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="pb-1">
                    <v-textarea
                            v-model="message"
                            :error-messages="messageErrors"
                            outlined
                            name="input-7-7"
                            label="Message"
                            value=""
                            @input="$v.message.$touch()"
                            @blur="$v.message.$touch()"
                            hide-details="auto"
                            class="btn-edu-height"
                    ></v-textarea>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="pb-4">
                    <v-btn
                            class="btn-edurent"
                            color="primary"
                            depressed
                            block
                            height="45"
                            @click="submit"
                            :loading="isCallingApi"
                            :disabled="$v.$anyDirty && $v.$invalid"
                    >
                        Send Message
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="submit-terms">
                    By submitting this form, you agree to EDUrent's<br>
                    <router-link :to="{ name: 'Terms' }" target="_blank">Terms of Service</router-link> and <router-link :to="{ name: 'Policy' }" target="_blank">Privacy Policy</router-link>.
                </v-col>
            </v-row>
        </form>

    </v-card>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import PropertyService from '../services/property.service'
import EngagementService from '../services/engagement.service'
import moment from "moment";
import UserService from "../services/user.service"

export default {
    name: 'ContactProperty',
    props: {
        property: {
            type: Object,
            required: true
        }
    },
    validations: {
        name: { required },
        email: { required, email },
        message: { required },
        propertyUnitId: { required },
        phone: {}
    },

    data: () => ({
        name: '',
        email: '',
        phone: '',
        message: 'Hi, I found your listing through EDUrent and I would like to schedule a viewing. Please contact me with more information. Thanks!',
        isCallingApi: false,
        showDob: false,
        propertyUnitId: null,
        moveInDate: new Date().toISOString().substr(0, 10),
        moveInDateFormatted: moment().format('l'),
        showPhoneNumber: false,
    }),
    watch: {
        moveInDate() {
          this.moveInDateFormatted = moment(this.moveInDate).format('l')
        }
    },
    computed: {
        nameErrors () {
            const errors = []
            if (!this.$v.name.$dirty) return errors
            !this.$v.name.required && errors.push('Name is required.')
            return errors
        },
        emailErrors () {
            const errors = []
            if (!this.$v.email.$dirty) return errors
            !this.$v.email.email && errors.push('Must be valid e-mail')
            !this.$v.email.required && errors.push('E-mail is required')
            return errors
        },
        messageErrors () {
            const errors = []
            if (!this.$v.message.$dirty) return errors
            !this.$v.message.required && errors.push('Message is required')
            return errors
        },
        propertyUnitErrors () {
            const errors = []
            if (!this.$v.propertyUnitId.$dirty) return errors
            !this.$v.propertyUnitId.required && errors.push('Available Unit is required')
            return errors
        },
        isUserLoggedIn() {
            return this.$store.getters.isUserLoggedIn;
        },
        user() {
            return this.$store.getters.getUser;
        },
        availableUnits () {
            let available_units = this.property.property_units
                .filter(unit => unit.property_unit_availabilities && unit.property_unit_availabilities.length)
                .map(unit => {
                    return {
                        ...unit,
                        select_label: `bd (${unit.number_of_bedrooms}) ba (${unit.number_of_baths}) $${Math.ceil(unit.price)} `
                    }
                })

            return available_units;
        },
        displayedImageId() {
            if (this.property && this.property.property_images && this.property.property_images.length > 0) {
                return this.property.property_images[0].id;
            }
            return null;
        }
    },
    methods: {
        openSignIn() {
            this.$store.dispatch('setSignInModal', true)
        },
        async submit () {
            if (!this.isUserLoggedIn) {
              this.$store.dispatch('setSignInModal', true)
              return
            }

            this.$v.$touch();
            if (this.$v.$invalid) {
                return
            }

            this.isCallingApi = true;

            const data = {
                name: this.name,
                email: this.email,
                phone: this.phone,
                message: this.message,
                date: this.moveInDateFormatted
            };

            // Include displayed_image_id for engagement tracking
            if (this.displayedImageId) {
                data.displayed_image_id = this.displayedImageId;
            }

            // send get info message
            await PropertyService.sendContactMessage(this.propertyUnitId, data);

            // Track contact engagement
            if (this.displayedImageId) {
                EngagementService.trackEngagement(this.displayedImageId, 'contact');
            }

            this.isCallingApi = false;
            this.clear();
        },
        clear () {
            this.$v.$reset()
            this.name = '';
            this.email = '';
            this.phone = '';
            this.message = '';
        },
        async onPropertyContact() {
            if(this.showPhoneNumber) {
                window.location.href = 'tel://' + this.property.phone_number;
            } else {
                this.showPhoneNumber = true;
                this.isCallingApi = true;

                const data = {
                    name: this.user.name,
                    email: this.user.email,
                    phone: this.user.phone,
                    message: "Hi, I found your listing through EDUrent and I would like to schedule a viewing. Please contact me with more information. Thanks!",
                    date: moment(this.user.university_start_date).format('l')
                };

                // Include displayed_image_id for engagement tracking
                if (this.displayedImageId) {
                    data.displayed_image_id = this.displayedImageId;
                }

                await PropertyService.sendContactMessage(this.property.id, data);

                // Track contact engagement
                if (this.displayedImageId) {
                    EngagementService.trackEngagement(this.displayedImageId, 'contact');
                }

                this.isCallingApi = false;
                this.clear();
            }
        },
        async checkContacted() {
            let referredProperties = await UserService.getContactedPropertyUnits(this.user.id);
            referredProperties.forEach(referral => {
                if(referral.property_unit.property_id === this.property.id) {
                    this.showPhoneNumber = true;
                    return;
                }
            });
        }
    },
    async beforeMount() {
        // set the menu to normal
        this.$store.commit('setHeaderMenuState');

        if (this.isUserLoggedIn) {
            this.name = this.user.name;
            this.email = this.user.email;
            this.phone = this.user.phone_number;
        }
        if(this.isUserLoggedIn) {
            await this.checkContacted();
        }
    }
}
</script>

<style>

    .contact-property {
        border-radius: 10px !important;
    }
    .contact-property h4 {
        font-size: 20px !important;
        font-weight: 700;
    }
    .contact-property .phone {
        font-size: 16px !important;
    }

    .contact-property .submit-terms {
        font-size: 12px !important;
        text-align: center;
    }

</style>
